import { render, staticRenderFns } from "./add-form.vue?vue&type=template&id=25fe1a22&scoped=true"
import script from "./add-form.vue?vue&type=script&lang=js"
export * from "./add-form.vue?vue&type=script&lang=js"
import style0 from "./add-form.vue?vue&type=style&index=0&id=25fe1a22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fe1a22",
  null
  
)

export default component.exports